<!-- 融资申请第三步 -->
<template>
  <section class="step3-form"
           :style="{minHeight:(screenHeight-85)+'px'}">
    <div v-if="this.$route.query.yanse == 1"  class="step-form__step-num2" >3/5</div>
    <div v-if="this.$route.query.yanse == 2" class="step-form__step-num" >3/5</div>
    <div class="step-form__main">
      <h1 class="step-form__title">{{this.$route.query.productName}}-应收账款</h1>
      <div class="step-form-container">
        <div class="step-from-top">
          <div class="amount-item">
            <p v-if="this.$route.query.yanse == 1" class="amount-title2">应收账款金额</p>
            <p v-if="this.$route.query.yanse == 2" class="amount-title">应收账款金额</p>
            <p class="amount-title-en"></p>
            <p :style="{fontSize:scaleSize(FrontVoucherInfoList.receivableAmountSum)}" class="amount-money"><em>¥</em>{{ FrontVoucherInfoList.receivableAmountSum | addThousandSign(2) }}</p>
          </div>
          <div class="amount-item">
            <p v-if="this.$route.query.yanse == 1" class="amount-title2">应收账款净额</p>
             <p v-if="this.$route.query.yanse == 2" class="amount-title">应收账款净额</p>
            <p class="amount-title-en"></p>
            <p :style="{fontSize:scaleSize(FrontVoucherInfoList.netAmountSum)}" class="amount-money"><em>¥</em>{{ FrontVoucherInfoList.netAmountSum | addThousandSign(2) }}</p>
          </div>
          <div class="amount-item">
            <div class="amount-item-top">
              <span class="amount-item-btn"
                    @click="addinfo" v-show="showAddBut">添加</span>
              <span class="amount-item-btn"
                    @click="fixinfo('checkinfo')">查看</span>
              <span class="amount-item-btn-import"
                    @click="importData" v-show="showAddBut">批量导入(EXCEL)</span>
            </div>
            <div class="amount-item-top">
              <span class="amount-item-btn"
                    @click="fixinfo('fix')" v-show="showAddBut">修改</span>
              <span class="amount-item-btn"
                    @click="deletinfo" v-show="showAddBut">删除</span>
              <span class="amount-item-btn-import"
                    @click="importData('ocr')" v-show="showAddBut">批量导入(OCR)</span>
            </div>
          </div>
        </div>
 <!-- 批量导入Excel -->
 <el-dialog title="批量导入(EXCEL)" :visible.sync="dialogImportVisibleExcel" :modal-append-to-body="false" :close-on-click-modal="false" class="dialog-import">
    <div :class="{'import-content': importFlag === 1, 'hide-dialog': importFlag !== 1}">
        <el-upload class="upload-demo"
          :action="importUrl"
          :name ="name"
          :data="excelData"
          :headers="importHeaders"
          :before-upload="beforeUploadImportExcel"
          :on-error="uploadFailImport"
          :on-success="uploadSuccessImport"
          :file-list="fileList"
          :with-credentials="withCredentials">
           <el-button size="small" type="primary" :disabled="processing">{{uploadTip}}</el-button>
           <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
        </el-upload>
      <div class="download">
           <el-button size="small" type="primary" @click="downTemplate" round>下载模板</el-button>
      </div>
        </div>
 </el-dialog>
 <!-- 批量导入Ocr -->
 <el-dialog title="增值税发票批量导入(OCR自动识别)" :visible.sync="dialogImportVisibleOcr" :modal-append-to-body="false" :close-on-click-modal="false" class="dialog-import" >
    <div :class="{'import-content': importFlag === 1, 'hide-dialog': importFlag !== 1}" class="financing-dialog" style="height: 150px;">
          <el-form :model="ruleForm"
                   :rules="rulesImport"
                   ref="ruleFormImport"
                   label-width="100px"
                   class="demo-ruleForm financing-dialog-form-body">
            <el-form-item label="买方"
                          prop="buyerId">
              <el-select v-model="ruleForm.buyerId"
                         placeholder="请选择买方"
                         class="buyerName">
                <el-option :label="item.buyerName"
                           :value="item.buyerId"
                           v-for="(item,index) in ruleForm.buyerNameList"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同编号"
                          prop="contractNumber">
              <el-input v-model="ruleForm.contractNumber"
                        placeholder="请输入合同编号"></el-input>
            </el-form-item>
             <el-form-item label="产品名称"
                          prop="baseProductId">
               <el-select v-model="ruleForm.baseProductId"  placeholder="请选择产品">
               <el-option
                  v-for="item in productList"
                  :key="item.productId"
                  :label="item.productName"
                  :value="item.productId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="签署日期"
                          prop="signDate">
              <el-date-picker type="date" @change="dateChange($event,'signDate')"
                              placeholder="签署日期"
                              v-model="ruleForm.signDate"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="el-form-item2">
            <el-upload class="upload-demo"
                :action="importUrl"
                :headers="importHeaders"
                :data="ocrData"
                :before-upload="beforeUploadImportOcr"
                :on-error="uploadFailImport"
                :on-success="uploadSuccessImportOcr"
                :file-list="fileList"
                :with-credentials="withCredentials">
                 <el-button size="small" type="primary" :disabled="processing">{{uploadTip}}</el-button>
                 <div slot="tip" class="el-upload__tip">请上传zip压缩文件（<span style="color:red">请将png\jpg\jpeg格式的发票图片打包上传，压缩包不超过50M。</span>）</div>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
          <div slot="footer"
              class="dialog__footer" style="margin-top: 3.5rem;">
            <span slot="footer" class="dialog-footer">
              <el-button  @click="importOcr">开始导入</el-button>
            </span>
          </div>
 </el-dialog>
        <div class="step-from-bottom">
          <ul class="step-list">
            <li>
              <span>
                <i @click="selectAll" class="select_All" :class="{checkbox_selectAll: selectAllState}"></i>
              </span>
              <span>买方</span>
              <span>类型</span>
              <span>凭证号码</span>
              <span>应收账款金额</span>
              <span v-if="$route.query.yanse == 2">审核状态</span>
              <span>应收账款净额</span>
            </li>
            <li v-for="(item, index) in tableData4"
                :key="index"
                @click="selectIcon(item)"
                class="step3-list-li">
              <div class="first_checkbox">
                <i :id="item.voucherInfoId"
                   :class="{ first_checkbox_select: selectList.indexOf(item.voucherInfoId) > -1}"></i>
              </div>
              <span :title="item.buyerName">{{ item.buyerName }}</span>
              <span :title="item.type">{{ item.type }}</span>
              <span :title="item.bizNo">{{ item.bizNo }}</span>
              <span :class="step3_blue2"
                    :title="item.receivableAmount">¥{{ item.receivableAmount | addThousandSign(2)}}</span>

              <span v-if="$route.query.yanse == 2" :title="item.authStateName">{{ item.authStateName }}</span>
              <span :class="step3_blue2"
                    :title="item.netAmount">¥{{ item.netAmount | addThousandSign(2) }}</span>

            </li>
          </ul>
          <div v-if="FrontVoucherInfoList.voucherInfoList.length == 0"
               class="noData">
            暂无数据
          </div>
          <div :class="this.$route.query.yanse == 1 ? 'step3-amount2' : 'step3-amount'">
            <span>已选应收账款金额：<i>¥{{receivablesAmountSum | addThousandSign(2)}}</i></span>
            <span>已选应收账款净额：<i>¥{{netAmountSum | addThousandSign(2)}}</i></span>
          </div>
          <el-pagination v-if="FrontVoucherInfoList.voucherInfoList.length > 0"
                         class="step3_pagination"
                         :page-size="8"
                         :total="FrontVoucherInfoList.voucherInfoCount"
                         :current-page="pageCurrent"
                         @current-change="changePage"
                         layout="prev, pager, next">
          </el-pagination>
        </div>
      </div>
      <div class="step-form__btn-container"
           v-if="showList">
      	  <button v-if="this.$route.query.yanse == 1 && this.FrontVoucherInfoList.frontApply.isReject == 1" class="step-form__btn-prev2"  @click="goBack">上一步</button>
          <button v-if="this.$route.query.yanse == 1" class="step-form__btn-next2"  @click="goNext">下一步</button>
          <button v-if="this.$route.query.yanse == 2" class="step-form__btn-prev"  @click="goBack">上一步</button>
          <button v-if="this.$route.query.yanse == 2" class="step-form__btn-next"  @click="goNext">下一步</button>
      </div>
      <div class="step-form__btn-container"
           v-else>
        <button class="step-form__btn-next"
                @click="showList = true">取消</button>
      </div>
    </div>
    <el-dialog :visible.sync="DialogInputBankInfo"
               top="5%"
               class="financing-dialog"
               :close-on-click-modal="false">
        <div class="financing-dialog-form">
          <el-form :model="ruleForm"
                   :rules="rules9"
                   ref="ruleForm9"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
            <el-form-item label="融资产品名称">
               <el-select v-model="ruleForm.baseProductId"
                          disabled
                          placeholder="">
                <el-option
                  v-for="(item, index) in productList"
                  :key="index"
                  :label="item.productName"
                  :value="item.productId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=""></el-form-item>
            <el-form-item label="贸易合同买方"
                          prop="buyerId">
              <el-select v-model="ruleForm.buyerId"
                         placeholder="请选择买方"
                         class="buyerName">
                <el-option :label="item.buyerName"
                           :value="item.buyerId"
                           v-for="(item,index) in ruleForm.buyerNameList"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="贸易合同编号"
                          prop="contractNumber">
              <el-input v-model="ruleForm.contractNumber"
                        placeholder="请输入贸易合同编号"></el-input>
            </el-form-item>
            <el-form-item label="贸易合同名称"
                          prop="contractName">
              <el-input v-model="ruleForm.contractName"
                        placeholder="请输入贸易合同名称"></el-input>
            </el-form-item>
          </el-form>
          <el-form :model="ruleForm"
                   :rules="rules"
                   ref="ruleForm"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
            <el-form-item label="凭证类型"
                          prop="type">
              <el-select v-model="ruleForm.type"
                         placeholder="请选择类型"
                         :disabled="voucherInfoId>0"
                         :onchange="changeFrom()">
                <el-option :label="item.label"
                           :value="item.value"
                           v-for="(item,index) in typeList"
                           :key="index"></el-option>
              </el-select>
             </el-form-item>
          </el-form>

           <el-form :model="ruleForm"

                   :rules="rules2"
                   ref="ruleForm2"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
            <template v-if="!dome">
              <el-form-item label="凭证日期"
                          prop="startTime">
              <el-date-picker type="date" @change="dateChange($event,'startTime')"
                              placeholder="凭证日期"
                              v-model="ruleForm.startTime"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="发票代码"
                          prop="invoiceCode">
              <el-input v-model="ruleForm.invoiceCode"
                        placeholder="请输入发票代码"></el-input>
            </el-form-item>
            <el-form-item label="发票校验码(后6位)"
                          prop="checkCode">
              <el-input v-model="ruleForm.checkCode" :maxlength="6"
                        placeholder="请输入发票校验码"></el-input>
            </el-form-item>
            <el-form-item label="凭证号码"
                          prop="lnvoiceNumber">
              <el-input v-model="ruleForm.lnvoiceNumber"
                        placeholder="请输入凭证号码"></el-input>
            </el-form-item>
            <el-form-item label="凭证金额"
                          prop="contractAmount">
              <el-input v-model="ruleForm.contractAmount"
                        placeholder="请输入凭证金额"></el-input>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input v-model="ruleForm.ddh"
                        placeholder="请输入订单号"></el-input>
            </el-form-item>
            <el-form-item label="送货单号">
              <el-input v-model="ruleForm.receiptNo"
                        placeholder="请输入送货单号"></el-input>
            </el-form-item>
            <el-form-item label="品名">
              <el-input v-model="ruleForm.goodsName"
                        placeholder="请输入品名"></el-input>
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input v-model="ruleForm.spec"
                        placeholder="请输入规格型号"></el-input>
            </el-form-item>
            <el-form-item label="数量">
              <el-input v-model="ruleForm.num"
                        placeholder="请输入数量"></el-input>
            </el-form-item>
            <el-form-item label="计量单位">
              <el-input v-model="ruleForm.unit"
                        placeholder="请输入计量单位"></el-input>
            </el-form-item>
            <el-form-item label="单价">
              <el-input v-model="ruleForm.unitPrice"
                        placeholder="请输入单价"></el-input>
            </el-form-item>
            <el-form-item label="总价"
                          prop="totalPrice">
              <el-input v-model="ruleForm.totalPrice"
                        placeholder="请输入总价"></el-input>
            </el-form-item>
            <el-form-item label="应收账款净额"
                          prop="netAmount">
              <el-input v-model="ruleForm.netAmount"
                        placeholder="请输入应收账款净额"></el-input>
            </el-form-item>
            <el-form-item label="签署日期"
                          prop="signDate">
              <el-date-picker type="date" @change="dateChange($event,'signDate')"
                              placeholder="签署日期"
                              v-model="ruleForm.signDate"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            </template>
          </el-form>
          <el-form :model="ruleForm"
                   :rules="rules3"
                   ref="ruleForm3"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
            <template v-if="dome1">
            <el-form-item label="订单日期"
                          prop="djTime">
              <el-date-picker type="date" @change="dateChange($event,'djTime')"
                              placeholder="订单日期"
                              v-model="ruleForm.djTime"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="订单号"
                          prop="deliveryNo">
              <el-input v-model="ruleForm.deliveryNo"
                        placeholder="请输入订单号"></el-input>
            </el-form-item>
           <el-form-item label="订单总值"
                          prop="ddnum">
              <el-input v-model="ruleForm.ddnum"
                        placeholder="请输入订单总值"></el-input>
            </el-form-item>
            <el-form-item label="品名"
                          prop="pm">
              <el-input v-model="ruleForm.pm"
                        placeholder="请输入品名"></el-input>
            </el-form-item>
            <el-form-item label="规格型号"
                          prop="ggxh">
              <el-input v-model="ruleForm.ggxh"
                        placeholder="请输入规格型号"></el-input>
            </el-form-item>
            <el-form-item label="单价"
                          prop="dj">
              <el-input v-model="ruleForm.dj"
                        placeholder="请输入单价"></el-input>
            </el-form-item>
            <el-form-item label="计量单位"
                          prop="dw">
              <el-input v-model="ruleForm.dw"
                        placeholder="请输入计量单位"></el-input>
            </el-form-item>
            <el-form-item label="数量"
                          prop="sl">
              <el-input v-model="ruleForm.sl"
                        placeholder="请输入数量"></el-input>
            </el-form-item>
            <el-form-item label="货物总值"
                          prop="zj">
              <el-input v-model="ruleForm.zj"
                        placeholder="请输入货物总值"></el-input>
            </el-form-item>
            <el-form-item label="应收账款净额"
                          prop="netAmount">
              <el-input v-model="ruleForm.netAmount"
                        placeholder="应收账款净额"></el-input>
            </el-form-item>
            <el-form-item label=""></el-form-item>
            </template>

          </el-form>
          <el-form :model="ruleForm"
                   :rules="rules4"
                   ref="ruleForm4"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
            <template v-if="dome2">
            <el-form-item label="单据日期"
                          prop="djTime2">
              <el-date-picker type="date" @change="dateChange($event,'djTime2')"
                              placeholder="单据日期"
                              v-model="ruleForm.djTime2"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="单据号码"
                          prop="shrk">
              <el-input v-model="ruleForm.shrk"
                        placeholder="请输入单据号码"></el-input>
            </el-form-item>
            <el-form-item label="单据总值"
                          prop="shnum">
              <el-input v-model="ruleForm.shnum"
                        placeholder="请输入单据总值"></el-input>
            </el-form-item>
            <el-form-item label="应收账款净额"
                          prop="netAmount">
              <el-input v-model="ruleForm.netAmount"
                        placeholder="应收账款净额"></el-input>
            </el-form-item>
            <el-form-item label=""></el-form-item>
            </template>


          </el-form>
          <el-form :model="ruleForm"
                   :rules="rules5"
                   ref="ruleForm5"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
            <template v-if="dome3">
            <el-form-item label="单据日期"
                          prop="djTime3">
              <el-date-picker type="date" @change="dateChange($event,'djTime3')"
                              placeholder="单据日期"
                              v-model="ruleForm.djTime3"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="单据号码"
                  prop="jsnum">
              <el-input v-model="ruleForm.jsnum"
                        placeholder="请输入单据号码"></el-input>
            </el-form-item>
            <el-form-item label="结算单总金额"
                          prop="jsdnum">
              <el-input v-model="ruleForm.jsdnum"
                        placeholder="请输入结算单总金额"></el-input>
            </el-form-item>
            <el-form-item label="应收账款净额"
                          prop="netAmount">
              <el-input v-model="ruleForm.netAmount"
                        placeholder="应收账款净额"></el-input>
            </el-form-item>
            <el-form-item label=""></el-form-item>
            </template>
          </el-form>
          <el-form :model="ruleForm"
                   :rules="rules6"
                   ref="ruleForm6"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
            <template v-if="dome5">
           <el-form-item label="票据号码"
                          prop="pjnum">
              <el-input v-model="ruleForm.pjnum"
                        placeholder="请输入票据号码"></el-input>
            </el-form-item>
            <el-form-item label="出票日期"
                          prop="cpTime">
              <el-date-picker type="date" @change="dateChange($event,'cpTime')"
                              placeholder="出票日期"
                              v-model="ruleForm.cpTime"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="汇票到期日"
                          prop="receivableEndTime">
              <el-date-picker type="date" @change="dateChange($event,'receivableEndTime')"
                              placeholder="汇票到期日"
                              v-model="ruleForm.receivableEndTime"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="出票人全称"
                          prop="cprqc">
              <el-input v-model="ruleForm.cprqc"
                        placeholder="请输入出票人全称"></el-input>
            </el-form-item>
            <el-form-item label="承兑人全称"
                          prop="cdrname">
              <el-input v-model="ruleForm.cdrname"
                        placeholder="请输入承兑人全称"></el-input>
            </el-form-item>
            <el-form-item v-bind:label="'承兑人开户行\n行号'"
                          prop="acceptorBankSwift" style="white-space: pre-line;">
              <el-input v-model="ruleForm.acceptorBankSwift"
                        placeholder="请输入承兑人开户行行号"></el-input>
            </el-form-item>
            <el-form-item v-bind:label="'承兑人开户行\n名称'"
                          prop="cdrkname" style="white-space: pre-line;">
              <el-input v-model="ruleForm.cdrkname"
                        placeholder="请输入承兑人开户行名称"></el-input>
            </el-form-item>
            <el-form-item label="票据金额"
                          prop="pmnum">
              <el-input v-model="ruleForm.pmnum"
                        placeholder="请输入票据金额"></el-input>
            </el-form-item>
              <el-form-item label="应收账款净额"
                            prop="netAmount">
                <el-input v-model="ruleForm.netAmount"
                          placeholder="应收账款净额"></el-input>
              </el-form-item>
            </template>
          </el-form>
          <el-form :model="ruleForm"
                   :rules="rules7"
                   ref="ruleForm7"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
            <template v-if="dome6">
           <el-form-item label="票据号码"
                          prop="pjnum2">
              <el-input v-model="ruleForm.pjnum2"
                        placeholder="请输入票据号码"></el-input>
            </el-form-item>
            <el-form-item label="出票日期"
                          prop="cpTime2">
              <el-date-picker type="date" @change="dateChange($event,'cpTime2')"
                              placeholder="出票日期"
                              v-model="ruleForm.cpTime2"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="汇票到期日"
                          prop="receivableEndTime2">
              <el-date-picker type="date" @change="dateChange($event,'receivableEndTime2')"
                              placeholder="汇票到期日"
                              v-model="ruleForm.receivableEndTime2"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="出票人全称"
                          prop="cprqc2">
              <el-input v-model="ruleForm.cprqc2"
                        placeholder="请输入出票人全称"></el-input>
            </el-form-item>
            <el-form-item label="承兑人全称"
                          prop="cdrname2">
              <el-input v-model="ruleForm.cdrname2"
                        placeholder="请输入承兑人全称"></el-input>
            </el-form-item>
            <el-form-item v-bind:label="'承兑人开户行\n行号'"
                          prop="acceptorBankSwift2" style="white-space: pre-line;">
              <el-input v-model="ruleForm.acceptorBankSwift2"
                        placeholder="请输入承兑人开户行行号"></el-input>
            </el-form-item>
            <el-form-item v-bind:label="'承兑人开户行\n名称'"
                          prop="cdrkname2" style="white-space: pre-line;">
              <el-input v-model="ruleForm.cdrkname2"
                        placeholder="请输入承兑人开户行名称"></el-input>
            </el-form-item>
            <el-form-item label="票据金额"
                          prop="pmnum2">
              <el-input v-model="ruleForm.pmnum2"
                        placeholder="请输入票据金额"></el-input>
            </el-form-item>
              <el-form-item label="应收账款净额"
                            prop="netAmount">
                <el-input v-model="ruleForm.netAmount"
                          placeholder="应收账款净额"></el-input>
              </el-form-item>
            </template>
          </el-form>
          <el-form :model="ruleForm"
                   :rules="rules8"
                   ref="ruleForm8"
                   label-width="125px"
                   class="demo-ruleForm financing-dialog-form-body">
            <template v-if="dome7">
              <el-form-item label="应收账款金额"
                            prop="contractAmount">
                <el-input v-model="ruleForm.contractAmount"
                          placeholder="请输入应收账款金额"></el-input>
              </el-form-item>
              <el-form-item label="应收账款净额"
                            prop="netAmount">
                <el-input v-model="ruleForm.netAmount"
                          placeholder="应收账款净额"></el-input>
              </el-form-item>
              <el-form-item label=""></el-form-item>
            </template>
          </el-form>
          <div style="margin-bottom: 2rem;margin-left: 2.5rem;">
            <span style="color:red;font-size: smaller;"> 温馨提示：<br>请将上述凭证的原件扫描图片或原件照片点击下方“+”号上传</span>
          </div>
        <ul class="file-list__item-list">
          <template v-for="file in sysFileIds">
            <li v-if="/\.pdf|\.doc|\.docx|\.xls|\.xlsx|\.rar|\.zip|\.7z/g.test(file.fileName)"
                :class="['file-list__item-preview', `file-list__${file.fileName.substr(file.fileName.lastIndexOf('.')+1)}-preview`]"
                @click.self="showPreviewImage(file.fileId, false)">
              <div class="file-list__item-delete"
                   @click="deleteUploadedFile(file.fileId)"
                   v-if='!(isFixType=="checkinfo")'>
                <i class="el-icon-close"></i>
              </div>
              <div class="file-list__file-name">{{file.fileName}}</div>
            </li>
            <li v-else
                class="file-list__item-preview">
              <img :src="`${ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${file.fileId}&tokenId=${tokenId}`"
                   @click="showPreviewImage(file.fileId, true)">
              <div class="file-list__item-delete"
                   @click.stop="deleteUploadedFile(file)"
                   v-if='!(isFixType=="checkinfo")'><i class="el-icon-close"></i></div>
            </li>
          </template>
          <li class="file-list__select-file picker"
              v-if='!(isFixType=="checkinfo") && sysFileIds.length < 5'>
            <i class="el-icon-plus"></i>
          </li>
        </ul>

      </div>
      <span slot="footer"
            class="dialog-footer"
            v-if="isFixType!='checkinfo'">
        <el-button :loading="isSubmitting" @click="sendInfo('step3list')">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog class="file-preview-modal"
               title="图片预览"
               :visible="filePreview.show"
               :before-close="hidePreviewImage"
               :close-on-click-modal="false">
      <div class="file-preview-modal__body">
        <img :src="filePreview.src"
             alt="图片预览">
      </div>
      <div slot="footer"
           class="dialog__footer">
        <button class="dialog__footer__confirm-btn"
                @click="hidePreviewImage">确定</button>
      </div>
    </el-dialog>

    <el-dialog class="progressDialog"
               title=" "
               :visible.sync="isShowProgress"
               size="tiny"
               top="20%"
               :show-close="false">
      <el-progress class="upload_progress"
                   :text-inside="true"
                   :stroke-width="18"
                   :percentage="progress"></el-progress>
    </el-dialog>
  </section>
</template>
<script>
import _ from 'lodash';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import * as types from '../../vuex/types/type';
import productsApi from '../../api/products/products.js';
import 'webuploader/css/webuploader.css';
import Webuploader from 'webuploader';
import applyloanApi from '../../api/applyloan/applyloan'; // 引入企业证件API
import billApi from '../../api/personalCenter/myBill.js';
import { Loading } from 'element-ui';

export default {
  data () {
    return {
      showAddBut:true,
      selectAllState: false,
      importUrl: '',
      importHeaders: {
        enctype: 'multipart/form-data'
      },
      ocrData: {},
      excelData: {},
      name: 'file',
      fileList: [],
      withCredentials: true,
      processing: false,
      uploadTip: '点击上传',
      importFlag: 1,
      dialogImportVisibleExcel: false,
      dialogImportVisibleOcr: false,
      step3_blue2: '',
      voucherInfoId: '',
      dome: false,
      dome1: false,
      dome2: false,
      dome3: false,
      dome5: false,
      dome6: false,
      dome7: false,
      yanse: '',
      countSysFile: 0,
      fullscreenLoading: false,
      loading: '',
      filePreview: {
        show: false,
        src: ''
      },
      sysFileIds: [],
      progress: 0,
      isShowProgress: false,
      tokenId: localStorage.getItem('dl_tokenId_bl'),
      FrontVoucherInfoList: {
        voucherInfoList: []
      },
      DialogInputBankInfo: false,
      approveList: [
        {
          label: '全部',
          value: ''
        }
      ],
      stateList: [
        {
          label: '全部',
          value: ''
        }
      ],
      typeList: [], // 凭证类型字典列表,
      productList: [], // 产品列表
      ruleForm: {
        netAmount:'',//应收账款净额
        baseProductId:'',//产品名称
        buyerId: '', // 买方（核心企业）名称
        type: '', // 凭证类型（默认为发票）
        buyerNameList: [],
        contractNumber: '', // 合同编号
        contractName: '', // 合同名称
        invoiceCode: '', // 发票代码
        checkCode: '', // 发票校验
        lnvoiceNumber: '', // 发票号码
        deliveryNo: '', // 订单号
        receiptNo: '', // 送货单号
        goodsName: '', // 品名
        spec: '', // 规格型号
        num: '', // 单位
        unit: '', // 数量
        unitPrice: '', // 单价
        totalPrice: '', // 总价
        contractAmount: '', // 发票金额
        drawer: '', // 出票人全称
        acceptor: '', // 承兑人全称
        acceptorBank: '', // 承兑人开户行名称
        alreadyPaidAmount: '0', // 已付款金额
        receivableEndTime: '', // 汇票到期日
        receivableEndTime2: '', // 汇票到期日
        startTime: '', // 开票日期
        djTime: '', // 订单中的单据日期
        htbh: '', // 订单中的合同编号
        ddh: '', // 订单中的订单号
        pm: '', // 订单中的品名
        ggxh: '', // 订单中的规格型号
        dw: '', // 订单中的单位
        sl: '', // 订单中的数量
        dj: '', // 订单中的单价
        zj: '', // 订单中的总价
        ddnum: '', // 订单总额
        djTime2: '', // 送货单/入库单的单据日期
        htbh2: '', // 送货单/入库单的合同编号
        pm2: '', // 送货单/入库单的品名
        shrk: '', // 送货/入库单号
        dd: '', // 送货单/入库单的订单号
        ggxh2: '', // 送货单/入库单的规格型号
        dw2: '', // 送货单/入库单的单位
        sl2: '', // 送货单/入库单的数量
        dj2: '', // 送货单/入库单的单价
        zj2: '', // 送货单/入库单的总价
        shnum: '', // 送货单/入库单的送货单金额
        djTime3: '', // 结算单的单据日期
        htbh3: '', // 结算单的合同编号
        pm3: '', // 结算单的品名
        jsnum: '', // 结算单号
        orderNo: '', // 结算单的收货单号
        ggxh3: '', // 结算单的规格型号
        dw3: '', // 结算单的单位
        sl3: '', // 结算单的数量
        dj3: '', // 结算单的单价
        zj3: '', // 结算单的总价
        jsdnum: '', // 结算单金额
        cpTime: '', // 银承的出票日期
        pjnum: '', // 银承的票据号码
        cprqc: '', // 银承的出票人全称
        cdrname: '', // 银承的承兑人全称
        cdrkname: '', // 银承的承兑人开户行
        pmnum: '', // 银承的票面金额
        cpTime2: '', // 银承的出票日期
        pjnum2: '', // 银承的票据号码
        cprqc2: '', // 银承的出票人全称
        cdrname2: '', // 银承的承兑人全称
        cdrkname2: '', // 银承的承兑人开户行
        pmnum2: '', // 银承的票面金额
        acceptorBankSwift:'',
        acceptorBankSwift2:'',
        signDate:'' // 签署日期
      },
      step3list: {
        voucherInfoId: '',
        type: '',
        buyerId: '',
        buyerName: '',
        contractNumber: '',
        waybillNumber: '',
        lnvoiceNumber: '',
        contractAmount: '',
        receivableAmount: '',
        receivableEndTime: '',
        state: '',
        alreadyPaidAmount: '0',
        filesName: ''
      },
      rules: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger:'blur' }],
        type: [{ type: 'string',
          required: true,
          message: '请选择类型',
          trigger:'change' }],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }]
      },

       rules2: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        type: [{ type: 'string',
          required: true,
          message: '请选择类型',
          trigger: 'change' }],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }],
        contractNumber: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入合同编号'));
              } else {
                callback();
              }
            }
          }
        ],
        invoiceCode: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入发票代码'));
              } else {
                callback();
              }
            }
          }
        ],
        checkCode: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入发票校验码'));
              } else {
                callback();
              }
            }
          }
        ],
        lnvoiceNumber: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入发票号码'));
              } else {
                callback();
              }
            }
          }
        ],
        contractAmount: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入发票金额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('发票金额必须为数字'));
              } else if (Number(value) < 0) {
                callback(new Error('发票金额不能小于0!'));
              } else {
                callback();
              }
            }
          }
        ],
        startTime: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择开票日期'));
              } else {
                callback();
              }
            }
          }
        ]

      },
      rules3: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        type: [{ type: 'string',
          required: true,
          message: '请选择类型',
          trigger: 'change' }],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }],
        htbh: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入合同编号'));
              } else {
                callback();
              }
            }
          }
        ],
        ddnum: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入订单总额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('订单总额必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        pm: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入品名'));
              } else {
                callback();
              }
            }
          }
        ],
        ggxh: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入规格型号'));
              } else {
                callback();
              }
            }
          }
        ],
        dw: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入单位'));
              } else {
                callback();
              }
            }
          }
        ],
        sl: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入数量'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('数量必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        dj: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入单价'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('单价必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        zj: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入总价'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('总价必须为数字'));
              } else if (Number(this.ruleForm.sl) * Number(this.ruleForm.dj) != Number(value)) {
                callback(new Error('总价不等于数量*单价之和'));
              } else {
                callback();
              }
            }
          }
        ],
        deliveryNo: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入订单号'));
              } else {
                callback();
              }
            }
          }
        ],
        djTime: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择单据日期'));
              } else if (
                new Date(value) >= new Date(this.ruleForm.receivableEndTime)
              ) {
                callback(new Error('开始时间不能大于等于结束时间'));
              } else {
                callback();
              }
            }
          }
        ]

      },
      rules4: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        type: [{ type: 'string',
          required: true,
          message: '请选择类型',
          trigger: 'change' }],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }],
        htbh2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入合同编号'));
              } else {
                callback();
              }
            }
          }
        ],
        shrk: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入送货/入库单号'));
              } else {
                callback();
              }
            }
          }
        ],

        shnum: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入送货单金额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('送货单金额必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],

        pm2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入品名'));
              } else {
                callback();
              }
            }
          }
        ],
        ggxh2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入规格型号'));
              } else {
                callback();
              }
            }
          }
        ],
        dw2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入单位'));
              } else {
                callback();
              }
            }
          }
        ],
        sl2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入数量'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('数量必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        dj2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入单价'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('单价必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        zj2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入总价'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('总价必须为数字'));
              } else if (Number(this.ruleForm.sl2) * Number(this.ruleForm.dj2) != Number(value)) {
                callback(new Error('总价不等于数量*单价之和'));
              } else {
                callback();
              }
            }
          }
        ],
        djTime2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择单据日期'));
              } else if (
                new Date(value) >= new Date(this.ruleForm.receivableEndTime)
              ) {
                callback(new Error('开始时间不能大于等于结束时间'));
              } else {
                callback();
              }
            }
          }
        ]

      },
      rules5: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        type: [{ type: 'string',
          required: true,
          message: '请选择类型',
          trigger: 'change' }],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }],
        htbh3: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入合同编号'));
              } else {
                callback();
              }
            }
          }
        ],
        pm3: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入品名'));
              } else {
                callback();
              }
            }
          }
        ],
        ggxh3: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入规格型号'));
              } else {
                callback();
              }
            }
          }
        ],
        dw3: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入单位'));
              } else {
                callback();
              }
            }
          }
        ],
        sl3: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入数量'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('数量必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        dj3: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入单价'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('单价必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        zj3: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入总价'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('总价必须为数字'));
              } else if (Number(this.ruleForm.sl3) * Number(this.ruleForm.dj3) != Number(value)) {
                callback(new Error('总价不等于数量*单价之和'));
              } else {
                callback();
              }
            }
          }
        ],
        orderNo: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入收货单号单号'));
              } else {
                callback();
              }
            }
          }
        ],
        jsnum: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入结算单号单号'));
              } else {
                callback();
              }
            }
          }
        ],
        jsdnum: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入结算单金额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('结算单金额必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        djTime3: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择单据日期'));
              } else if (
                new Date(value) >= new Date(this.ruleForm.receivableEndTime)
              ) {
                callback(new Error('开始时间不能大于等于结束时间'));
              } else {
                callback();
              }
            }
          }
        ]

      },
      rules6: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        type: [{ type: 'string',
          required: true,
          message: '请选择类型',
          trigger: 'change' }],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }],
        pmnum: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入票面金额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('票面金额必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],

        cdrkname: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入承兑人开户行'));
              } else {
                callback();
              }
            }
          }
        ],
        cprqc: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入出票人全称'));
              } else {
                callback();
              }
            }
          }
        ],
        cdrname: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入承兑人全称'));
              } else {
                callback();
              }
            }
          }
        ],
        acceptorBankSwift: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入承兑人开户行行号'));
              } else {
                callback();
              }
            }
          }
        ],
        pjnum: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入票据号码'));
              } else {
                callback();
              }
            }
          }
        ],
        cpTime: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择出票日期'));
              } else if (
                new Date(value) >= new Date(this.ruleForm.receivableEndTime)
              ) {
                callback(new Error('开始时间不能大于等于结束时间'));
              } else {
                callback();
              }
            }
          }
        ],

        receivableEndTime: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择汇票到期日'));
              } else if (
                new Date(value) <=
                new Date(
                  this.ruleForm.cpTime
                    ? this.ruleForm.cpTime
                    : '1970-01-01'
                )
              ) {
                callback(new Error('结束时间不能小于等于开始时间'));
              } else if (
                new Date(value).getTime() + 57600000 <
                new Date().getTime()
              ) {
                callback(new Error('结束时间不能早于当前时间'));
              } else {
                callback();
              }
            }
          }
        ]

      },
      rules7: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        type: [{ type: 'string',
          required: true,
          message: '请选择类型',
          trigger: 'change' }],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }],
        pmnum2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入票面金额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('票面金额必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        cdrkname2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入承兑人开户行'));
              } else {
                callback();
              }
            }
          }
        ],
        cdrname2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入承兑人全称'));
              } else {
                callback();
              }
            }
          }
        ],
        acceptorBankSwift2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入承兑人开户行行号'));
              } else {
                callback();
              }
            }
          }
        ],
        cprqc2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入出票人全称'));
              } else {
                callback();
              }
            }
          }
        ],
        pjnum2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入票据号码'));
              } else {
                callback();
              }
            }
          }
        ],
        cpTime2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择单据日期'));
              } else if (
                new Date(value) >= new Date(this.ruleForm.receivableEndTime)
              ) {
                callback(new Error('开始时间不能大于等于结束时间'));
              } else {
                callback();
              }
            }
          }
        ],
        receivableEndTime2: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择汇票到期日'));
              } else if (
                new Date(value) <=
                new Date(
                  this.ruleForm.cpTime2
                    ? this.ruleForm.cpTime2
                    : '1970-01-01'
                )
              ) {
                callback(new Error('结束时间不能小于等于开始时间'));
              } else if (
                new Date(value).getTime() + 57600000 <
                new Date().getTime()
              ) {
                callback(new Error('结束时间不能早于当前时间'));
              } else {
                callback();
              }
            }
          }
        ]
      },
      rules8: {
        contractAmount: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入应收账款金额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('应收账款金额必须为数字'));
              } else if (Number(value) < 0) {
                callback(new Error('应收账款金额不能小于0!'));
              } else {
                callback();
              }
            }
          }
        ],
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        type: [{ type: 'string',
          required: true,
          message: '请选择类型',
          trigger: 'change' }],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }]
      },
      rules9: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        baseProductId: [{
          type: 'number',
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }],
        contractNumber: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入贸易合同编号'));
              } else {
                callback();
              }
            }
          }
        ],
        contractName: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入贸易合同名称'));
              } else {
                callback();
              }
            }
          }
        ]
      },
      rulesImport: {
        buyerId: [{ type: 'number',
          required: true,
          message: '请选择买方',
          trigger: 'blur' }],
        contractNumber: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入合同编号'));
              } else {
                callback();
              }
            }
          }
        ],
        baseProductId: [{
          type: "number",
          required: true,
          message: '请选择产品',
          trigger: 'blur'
        }]
      },
      step3listRules: {
        buyerId: [
          {
            type: 'number',
            trigger: 'change',
            required: true,
            message: '请选择买方公司名称'
          }
        ],
        type: [{ type: 'string',
          required: true,
          message: '请选择类型',
          trigger: 'change' }],
        contractNumber: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入商务合同号'));
              } else {
                callback();
              }
            }
          }
        ],
        waybillNumber: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入运单号'));
              } else {
                callback();
              }
            }
          }
        ],
        lnvoiceNumber: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请输入发票号'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('发票号必须为数字'));
              } else {
                callback();
              }
            }
          }
        ],
        contractAmount: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (value.toString().trim() === '') {
                callback(new Error('请输入发票合同金额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('发票合同金额必须为数字'));
              } else if (Number(value) < 0) {
                callback(new Error('发票合同金额不能小于0!'));
              } else {
                callback();
              }
            }
          }
        ],
        advanceChargeAmount: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (value.toString().trim() === '') {
                callback(new Error('请输入预付款金额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('预付款金额必须为数字'));
              } else if (Number(value) < 0) {
                callback(new Error('预付金额不能小于0!'));
              } else if (Number(value) > this.step3list.contractAmount) {
                callback(new Error('预付金额必须小于发票合同金额'));
              } else {
                callback();
              }
            }
          }
        ],
        alreadyPaidAmount: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (value.toString().trim() === '') {
                callback(new Error('请输入已付款金额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('已付款金额必须为数字'));
              } else if (Number(value) < 0) {
                callback(new Error('已付款金额不能小于0!'));
              } else if (Number(value) > this.step3list.receivableAmount) {
                callback(new Error('已付款金额必须小于应收账款金额'));
              } else {
                callback();
              }
            }
          }
        ],
        receivableAmount: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (value.toString().trim() === '') {
                callback(new Error('请输入应收账款金额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('应收账款金额必须为数字'));
              } else if (Number(value) < 0) {
                callback(new Error('应收账款金额不能小于0!'));
              } else if (Number(value) > this.step3list.contractAmount) {
                callback(new Error('应收账款金额必须小于发票合同金额'));
              } else {
                callback();
              }
            }
          }
        ],
        commissionAmount: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (value.toString().trim() === '') {
                callback(new Error('请输入佣金及转让金额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('佣金及转让金额必须为数字'));
              } else if (Number(value) < 0) {
                callback(new Error('佣金及转让金额不能小于0!'));
              } else if (Number(value) > this.step3list.receivableAmount) {
                callback(new Error('佣金及转让金额应小于等于应收账款金额'));
              } else {
                callback();
              }
            }
          }
        ],
        receivableStartTime: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择应收账款开始时间'));
              } else if (
                new Date(value) > new Date(this.step3list.receivableEndTime)
              ) {
                callback(new Error('开始时间不能大于结束时间'));
              } else {
                callback();
              }
            }
          }
        ],
        receivableEndTime: [
          {
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择应收账款结束时间'));
              } else if (
                new Date(value) <
                new Date(
                  this.step3list.receivableStartTime
                    ? this.step3list.receivableStartTime
                    : '1970-01-01'
                )
              ) {
                callback(new Error('结束时间不能小于开始时间'));
              } else if (
                new Date(value).getTime() + 57600000 <
                new Date().getTime()
              ) {
                callback(new Error('结束时间不能早于当前时间'));
              } else {
                callback();
              }
            }
          }
        ]
      },
      buyNameList: [],
      selectList: [],
      pageCurrent: 1,
      pageSize: 8,
      isFixType: '',
      showList: true,
      isSubmitting: false,
      selectedBankcardId: '',
      screenHeight: document.body.clientHeight,
      tableData3: [],
      tableData4: [],
      amount: {
        receivablesAmount: 0,
        netAmount:0
      }
    };
  },
  computed: {
    ...mapGetters({
      ajaxBaseUrl: types.GET_AJAX_BASE_URL,
      userInfo: types.GET_USER,
      bankcardList: types.GET_BANKCARD_LIST,
      cardTypeList: types.GET_CARD_TYPE_LIST,
      regionData: types.GET_REGION_DATA,
      selectedBankID: types.GET_SELECTED_BANK_ID_STATE,
      selectedBankNO: types.GET_SELECTED_BANK_NO_STATE
    }),
    receivablesAmountSum(){
      let result = 0;
      this.selectList.forEach(item => {
        let voucherInfo = this.tableData3.find((voucher) => voucher.voucherInfoId == item);
        result += voucherInfo.receivableAmount
      });
      return result;
    },
    netAmountSum(){
      let result = 0;
      this.selectList.forEach(item => {
        let voucherInfo = this.tableData3.find((voucher) => voucher.voucherInfoId == item);
        result += voucherInfo.netAmount
      });
      return result;
    }
  },
  watch:{
    selectList(){
      let pageList = this.tableData4;
      if (pageList.length == 0) {
        return false;
      }
      this.selectAllState = this.tableData4.every((item) => this.selectList.includes(item.voucherInfoId))
    }
  },
  methods: {
    ...mapActions({
      getBankcardList: types.SET_BANKCARD_LIST,
      getProvinceData: types.SET_PROVINCE_DATA,
      getCityAndDistrictData: types.SET_CITY_AND_DISTRICT_DATA,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setFailMessage: types.SET_FAIL_MESSAGE
    }),
    ...mapMutations({
      setSelectedBankcard: types.SELECT_BANKCARD,
      setSelectedBankID: types.SET_SELECTED_BANK_ID_STATE,
      setSelectedBankNO: types.SET_SELECTED_BANK_NO_STATE
    }),

    getByNodeKeyPC (param) {
      billApi.getByNodeKeyPC(param).then((res) => {
        this.stateList = this.stateList.concat(res[0]);
        this.approveList = this.approveList.concat(res[1]);
        this.typeList = this.typeList.concat(res[2]);
      });
    },

    getProductList(){
        productsApi.getProductListData({
          tokenId: localStorage.getItem('dl_tokenId_bl')
        }).then((res) => {
          if (Number(res.rspcode) === 1) {
            this.productList = res.data.proList;
          }
      });
    },

    changeFrom () {
      this.isSubmit = false;
      this.isValidate = false;
      if (this.$refs.ruleForm3) {
        this.$refs.ruleForm3.resetFields();
      } else if (this.$refs.ruleForm4) {
        this.$refs.ruleForm4.resetFields();
      } else if (this.$refs.ruleForm5) {
        this.$refs.ruleForm5.resetFields();
      } else if (this.$refs.ruleForm6) {
        this.$refs.ruleForm6.resetFields();
      } else if (this.$refs.ruleForm7) {
        this.$refs.ruleForm7.resetFields();
      } else if (this.$refs.ruleForm8) {
        this.$refs.ruleForm8.resetFields();
      }

      if (this.ruleForm.type == 1) {
        this.dome1 = true;
        this.dome = true;
        this.dome2 = false;
        this.dome3 = false;
        this.dome5 = false;
        this.dome6 = false;
        this.dome7 = false;
      } else if (this.ruleForm.type == 2) {
        this.dome1 = false;
        this.dome = true;
        this.dome2 = true;
        this.dome3 = false;
        this.dome5 = false;
        this.dome6 = false;
        this.dome7 = false;
      } else if (this.ruleForm.type == 3) {
        this.dome1 = false;
        this.dome = true;
        this.dome2 = false;
        this.dome3 = true;
        this.dome5 = false;
        this.dome6 = false;
        this.dome7 = false;
      } else if (this.ruleForm.type == 4) {
        this.dome1 = false;
        this.dome = false;
        this.dome2 = false;
        this.dome3 = false;
        this.dome5 = false;
        this.dome6 = false;
        this.dome7 = false;
      } else if (this.ruleForm.type == 5) {
        this.dome1 = false;
        this.dome = true;
        this.dome2 = false;
        this.dome3 = false;
        this.dome5 = true;
        this.dome6 = false;
        this.dome7 = false;
      } else if (this.ruleForm.type == 6) {
        this.dome1 = false;
        this.dome = true;
        this.dome2 = false;
        this.dome3 = false;
        this.dome5 = false;
        this.dome6 = true;
        this.dome7 = false;
      } else if (this.ruleForm.type == 7) {
        this.dome1 = false;
        this.dome = true;
        this.dome2 = false;
        this.dome3 = false;
        this.dome5 = false;
        this.dome6 = false;
        this.dome7 = true;
      }
    },
    // 初始化买方数据
    buyerNameData () {
      billApi.addFrontVoucherInfoPage({
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        frontApplyId: 0
      }).then((res) => {
        if (res.rspcode == 1) {
          this.ruleForm.buyerNameList = res.data;
        }
      }).catch((error) => {});
    },
    goBack () {
      this.$router.push({
          name: "step3_bak_bl",
          params:this.$route.params,
          query:this.$route.query
      });
    },
    scaleSize (scaleNum) {
      var k = 10000,
      i;
      i = Math.log(scaleNum) / Math.log(k);
      if (i > 1) {
        let caleNum = 26 * (1 / i + 0.3);
        return `${caleNum}px`;
      } else {
        this.scaleNum = 1;
        return `26px`;
      }
    },
    goNext () {
      if (this.selectList.length) {
        this.fullscreenLoading = true;
        // 选中凭证保存接口
        const param = {
          voucherInfoIds: this.selectList.join(','),
          tokenId: localStorage.getItem('dl_tokenId_bl'),
          frontApplyId: this.$route.query.frontApplyId
        };
        applyloanApi
          .saveFrontVoucherInfoList(param)
          .then((res) => {
            this.fullscreenLoading = false;
            if (res.rspcode === 1) {
              this.$router.push({
                path: `/applyLoan/${this.$route.params.id}/step4_bl`,
                query: {
                  frontApplyId: this.$route.query.frontApplyId,
                  yanse: this.$route.query.yanse,
                  productName: this.$route.query.productName
                }
              });
            } else {
              this.setFailMessage({
                show: true,
                content: res.rspdesc || '数据获取失败'
              });
            }
          })
          .catch((error) => {
            this.fullscreenLoading = false;
            this.setFailMessage({
              show: true,
              content: '网络异常，请稍后再试'
            });
          });
      } else {
        this.setFailMessage({
          show: true,
          content: '请先勾选凭证'
        });
      }
    },
    getFrontVoucherInfoList () {
      const param = {
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        frontApplyId: this.$route.query.frontApplyId,
        type: 'list',
        state: '12',
        notInAuthResult: '2',
        baseProductId: this.$route.params.id,
        pageNum: 1,
        pageSize: 999
      };
      applyloanApi
        .getFrontVoucherInfoList(param)
        .then((res) => {
          if (res.rspcode === 1) {
            this.FrontVoucherInfoList = res.data;
            this.tableData3 = res.data.voucherInfoList;
            this.tableData4 =
              this.pageSize >= res.data.voucherInfoList.length
                ? res.data.voucherInfoList.slice(
                    0,
                    res.data.voucherInfoList.length
                  )
                : res.data.voucherInfoList.slice(0, this.pageSize);
            res.data.voucherInfoList.map((item, index) => {
              if (item.frontApplyId == this.$route.query.frontApplyId) {
                this.selectList.push(item.voucherInfoId);
              }
            });
            this.changePage(this.pageCurrent);
          } else {
            this.setFailMessage({
              show: true,
              content: res.rspdesc || '数据获取失败'
            });
          }
        });
    },

    //      分页调用
    changePage (currentPage) {
      this.pageCurrent = currentPage;
      const offset = (currentPage - 1) * this.pageSize;
      this.tableData4 =
        offset + this.pageSize >= this.tableData3.length
          ? this.tableData3.slice(offset, this.tableData3.length)
          : this.tableData3.slice(offset, offset + this.pageSize);

      this.selectAllState = this.tableData4.every((item) => this.selectList.includes(item.voucherInfoId))
    },
    //      买方公司列表数据
    addFrontVoucherInfoPage (param) {
      applyloanApi
        .addFrontVoucherInfoPage(param)
        .then((res) => {
          if (res.rspcode === 1) {
            this.buyNameList = res.data;
          } else {
            this.setFailMessage({
              show: true,
              content: res.rspdesc || '数据获取失败'
            });
          }
        })
        .catch((error) => {
          this.setFailMessage({
            show: true,
            content: '网络异常，请稍后再试'
          });
        });
    },

    //      添加接口
    addinfo () {
      this.isFixType = 'add';
      this.DialogInputBankInfo = true;
      this.isMasking = true;
      this.voucherInfoId = '';
      this.emptyData();
      this.buyerNameData();
      this.sysFileIds = [];
      document.documentElement.style.overflowY = 'hidden';
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
      this.ruleForm.type = '4';
      // if (this.uploader == undefined) {
        const _this = this;
        setTimeout(() => {
          _this.createWebUploader();
          _this.uploader.refresh();
        }, 500);
      // }
      this.ruleForm.baseProductId = Number(this.$route.params.id);
    },
    // 清空数据数据
    emptyData () {
      this.ruleForm = {
        buyerId: '', // 买方（核心企业）名称
        type: '', // 凭证类型
        buyerNameList: [],
        contractNumber: '', // 合同编号
        contractName: '', // 合同编号
        invoiceCode: '', // 发票代码
        checkCode: '', // 发票校验码
        lnvoiceNumber: '', // 发票号码
        deliveryNo: '', // 订单号
        receiptNo: '', // 送货单号
        receivableEndTime: '', // 汇票到期日
        receivableEndTime2: '', // 汇票到期日
        startTime: '', // 开票日期
        djTime: '', // 订单中的单据日期
        htbh: '', // 订单中的合同编号
        ddh: '', // 订单中的订单号
        pm: '', // 订单中的品名
        ggxh: '', // 订单中的规格型号
        dw: '', // 订单中的单位
        sl: '', // 订单中的数量
        dj: '', // 订单中的单价
        zj: '', // 订单中的总价
        ddnum: '', // 订单总额
        djTime2: '', // 送货单/入库单的单据日期
        htbh2: '', // 送货单/入库单的合同编号
        pm2: '', // 送货单/入库单的品名
        shrk: '', // 送货/入库单号
        dd: '', // 送货单/入库单的订单号
        ggxh2: '', // 送货单/入库单的规格型号
        dw2: '', // 送货单/入库单的单位
        sl2: '', // 送货单/入库单的数量
        dj2: '', // 送货单/入库单的单价
        zj2: '', // 送货单/入库单的总价
        shnum: '', // 送货单/入库单的送货单金额
        djTime3: '', // 结算单的单据日期
        htbh3: '', // 结算单的合同编号
        pm3: '', // 结算单的品名
        jsnum: '', // 结算单号
        orderNo: '', // 结算单的收货单号
        ggxh3: '', // 结算单的规格型号
        dw3: '', // 结算单的单位
        sl3: '', // 结算单的数量
        dj3: '', // 结算单的单价
        zj3: '', // 结算单的总价
        jsdnum: '', // 结算单金额
        cpTime: '', // 银承的出票日期
        pjnum: '', // 银承的票据号码
        cprqc: '', // 银承的出票人全称
        cdrname: '', // 银承的承兑人全称
        cdrkname: '', // 银承的承兑人开户行
        pmnum: '', // 银承的票面金额
        cpTime2: '', // 银承的出票日期
        pjnum2: '', // 银承的票据号码
        cprqc2: '', // 银承的出票人全称
        cdrname2: '', // 银承的承兑人全称
        cdrkname2: '', // 银承的承兑人开户行
        pmnum2: '', // 银承的票面金额
        acceptorBankSwift:'',
        acceptorBankSwift2:''
      };
    },
    // 修改和查看接口
    fixinfo (type) {
      document.documentElement.style.overflowY = 'hidden';
      // 获取买方名称列表
      this.addFrontVoucherInfoPage({
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        frontApplyId: this.$route.query.frontApplyId
      });

      this.isFixType = type === 'fix' ? 'fix' : 'checkinfo';
      if (!(this.selectList.length == 1)) {
        this.setFailMessage({
          show: true,
          content: `请选择${type === 'fix' ? '修改' : '查看'}一条数据`
        });
        this.isFixType = "";
        return;
      } else {
        if (type == 'fix') {
        	for (let i = 0; i < this.tableData4.length; i++) {
        	    if (this.selectList.join('') == this.tableData4[i].voucherInfoId && this.tableData4[i].state == '审核通过') {
			        this.setFailMessage({
			          show: true,
			          content: `审批通过的凭证不允许修改`
			        });
			        return;
        	    }
        	}
        }
        // if (this.uploader == undefined) {
          const _this = this;
          setTimeout(() => {
            _this.createWebUploader();
            _this.uploader.refresh();
          }, 1000);
        // } else {
        //   this.uploader.reset();
        // }
        setTimeout(() => {
          document.getElementsByClassName('financing-dialog')[0].scrollTop = 0;
        }, 100);

        const voucherInfoIdString = this.selectList;
        this.voucherInfoId = voucherInfoIdString.join('');

        billApi.getFrontVoucherInfoDetails({
          voucherInfoId: this.voucherInfoId,
          tokenId: localStorage.getItem('dl_tokenId_bl')
        }).then((res) => {
          if (res.rspcode == 1) {
            this.DialogInputBankInfo = true;
            const end = this.formTime(
              res.data.voucherInfo.accountsReceivableEndTime
            );
            const start = this.formTime(
              res.data.voucherInfo.accountsReceivableStartTime
            );
            this.sysFileIds = res.data.voucherInfo.sysFileIds
              ? JSON.parse(res.data.voucherInfo.sysFileIds.replace(/\'/g, '"'))
              : [];
            let typeData = {};
            // 订单
            if (res.data.voucherInfo.type == 1) {
              typeData = {
                djTime: start, // 开票日期
                contractNumber: res.data.voucherInfo.contractNumber, // 合同编号
                contractName: res.data.voucherInfo.contractName, // 合同名称
                deliveryNo: res.data.voucherInfo.bizNo, // 订单号
                pm: res.data.order.goodsName, // 品名
                ggxh: res.data.order.spec, // 规格型号
                dw: res.data.order.unit, // 单位
                sl: res.data.order.num, // 数量
                dj: res.data.order.unitPrice, // 单价
                zj: res.data.order.totalPrice, // 总价
                ddnum: res.data.voucherInfo.accountsReceivableAmount // 发票金额
              };
            }
            // 送货单/入库单
            if (res.data.voucherInfo.type == 2) {
              typeData = {
                djTime2: start, // 开票日期
                contractNumber: res.data.voucherInfo.contractNumber, // 合同编号
                contractName: res.data.voucherInfo.contractName, // 合同名称
                shrk: res.data.voucherInfo.bizNo, // 送货单号
                dd: res.data.order.orderNo,
                pm2: res.data.order.goodsName, // 品名
                ggxh2: res.data.order.spec, // 规格型号
                dw2: res.data.order.unit, // 单位
                sl2: res.data.order.num, // 数量
                dj2: res.data.order.unitPrice, // 单价
                zj2: res.data.order.totalPrice, // 总价
                shnum: res.data.voucherInfo.accountsReceivableAmount // 发票金额
              };
            }
            // 结算单
            if (res.data.voucherInfo.type == 3) {
              typeData = {
                djTime3: start, // 开票日期
                contractNumber: res.data.voucherInfo.contractNumber, // 合同编号
                contractName: res.data.voucherInfo.contractName, // 合同名称
                jsnum: res.data.voucherInfo.bizNo, // 结算单号
                orderNo: res.data.order.receiptNo,  // 收货单号
                pm3: res.data.order.goodsName, // 品名
                ggxh3: res.data.order.spec, // 规格型号
                dw3: res.data.order.unit, // 单位
                sl3: res.data.order.num, // 数量
                dj3: res.data.order.unitPrice, // 单价
                zj3: res.data.order.totalPrice, // 总价
                jsdnum: res.data.voucherInfo.accountsReceivableAmount // 发票金额
              };
            }
            // 发票
            if (res.data.voucherInfo.type == 4) {
              typeData = {
                startTime: start, // 开票日期
                contractNumber: res.data.voucherInfo.contractNumber, // 合同编号
                contractName: res.data.voucherInfo.contractName, // 合同名称
                invoiceCode: res.data.voucherInfo.invoiceCode, // 发票代码
                checkCode: res.data.voucherInfo.checkCode, // 发票校验码
                lnvoiceNumber: res.data.voucherInfo.bizNo, // 发票号码
                ddh: res.data.order.orderNo, // 订单号
                receiptNo: res.data.order.deliveryNo, // 送货单号
                goodsName: res.data.order.goodsName, // 品名
                spec: res.data.order.spec, // 规格型号
                unit: res.data.order.unit, // 单位
                num: res.data.order.num, // 数量
                unitPrice: res.data.order.unitPrice, // 单价
                totalPrice: res.data.order.totalPrice, // 总价
                contractAmount: res.data.voucherInfo.accountsReceivableAmount, // 发票金额
                signDate: res.data.voucherInfo.signDate // 签署日期
              };
            }
            // 银承
            if (res.data.voucherInfo.type == 5) {
              typeData = {
                cpTime: start, // 出票日期
                receivableEndTime: end, // 汇票到期日
                pjnum: res.data.voucherInfo.bizNo, // 票据号码
                cprqc: res.data.bill.drawer, // 出票人全称
                cdrname: res.data.bill.acceptor, // 承兑人全称
                cdrkname: res.data.bill.acceptorBank, // 承兑人开户行
                acceptorBankSwift:res.data.bill.acceptorBankSwift,//承兑人开户行行号
                contractNumber: res.data.voucherInfo.contractNumber, // 合同编号
                contractName: res.data.voucherInfo.contractName, // 合同名称
                pmnum: res.data.voucherInfo.accountsReceivableAmount // 票面金额
              };
            }
            // 商承
            if (res.data.voucherInfo.type == 6) {
              typeData = {
                cpTime2: start, // 出票日期
                receivableEndTime2: end, // 汇票到期日
                pjnum2: res.data.voucherInfo.bizNo, // 票据号码
                cprqc2: res.data.bill.drawer, // 出票人全称
                cdrname2: res.data.bill.acceptor, // 承兑人全称
                cdrkname2: res.data.bill.acceptorBank, // 承兑人开户行
                acceptorBankSwift2:res.data.bill.acceptorBankSwift,//承兑人开户行行号
                contractNumber: res.data.voucherInfo.contractNumber, // 合同编号
                contractName: res.data.voucherInfo.contractName, // 合同名称
                pmnum2: res.data.voucherInfo.accountsReceivableAmount // 票面金额
              };
            }
            const _sysFileIds = res.data.voucherInfo.sysFileIds
              ? JSON.parse(res.data.voucherInfo.sysFileIds.replace(/\'/g, '"'))
              : [];
            this.ruleForm = {
              type: res.data.voucherInfo.type, // 凭证类型
              buyerId: res.data.voucherInfo.buyerId, // 买方（核心企业）名称
              buyerNameList: [],
              ...typeData,
              sysFileIds: _sysFileIds,
              netAmount:res.data.voucherInfo.netAmount, //应收账款净额
              baseProductId: res.data.voucherInfo.baseProductId
            };
          }
          this.buyerNameData();
        })
        .catch((error) => {});
      }
    },
    // 删除接口
    deletinfo () {
      if (this.selectList.length) {
      this.$confirm('是否确定删除所选凭证?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            let canAllDelete = this.selectList.every(selectId => {
              let selectItem = this.tableData4.find((item) => item.voucherInfoId == selectId);
              return selectItem.canDelete
            });
            if(!canAllDelete){
                this.setFailMessage({
                  show: true,
                  content: `选中的凭证中存在不能删除的凭证`
                });
                return;
             }

            const voucherInfoIdsString = this.selectList;
            const param = {
              tokenId: localStorage.getItem('dl_tokenId_bl'),
              voucherInfoIds: voucherInfoIdsString.join(',')
            };
            applyloanApi
              .delVoucherInfo(param)
              .then((res) => {
                if (res.rspcode === 1) {
                  this.setSuccessMessage({
                    show: true,
                    content: res.rspdesc
                  });
                  this.DialogInputBankInfo = false;
                  this.getFrontVoucherInfoList();
                  this.selectList = [];
                  this.selectAllState = false;
                } else {
                  this.setFailMessage({
                    show: true,
                    content: res.rspdesc || '数据获取失败'
                  });
                }
              })
              .catch((error) => {
                this.setFailMessage({
                  show: true,
                  content: '网络异常，请稍后再试'
                });
              });
        });
      } else {
        this.setFailMessage({
          show: true,
          content: '请先选中要删除的数据'
        });
      }
    },
    // 关闭弹窗
    close () {
      this.DialogInputBankInfo = false;
    },
    //      添加提交
    sendInfo (formName) {
      const ruleFormType = this.ruleForm.type;
      const codeSysfiled =  encodeURIComponent(JSON.stringify(this.sysFileIds))
      const sameType = {
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        voucherInfoId: this.voucherInfoId || 0, // 凭证id(主键)
        frontApplyId: 0, // 项目id
        type: ruleFormType, // 类型
        buyerId: this.ruleForm.buyerId, // 买方
        sysFileIds: codeSysfiled,// 附件
        netAmount:this.ruleForm.netAmount, //应收账款净额
        baseProductId: this.ruleForm.baseProductId // 产品id
      };
      let params = {};
      this.$refs.ruleForm9.validate((valid) => {
        if (valid) {
          this.isValidate = true;
        }
      });

      if (ruleFormType == '2') {
        this.$refs.ruleForm4.validate((valid) => {
          if (valid && this.isValidate) {
            this.isSubmit = true;
            // 送货单/入库单
            params = {
              ...sameType,
              receivableStartTime: this.ruleForm.djTime2, // 开票日期
              receivableEndTime: '', // 结束日期
              contractNumber: this.ruleForm.contractNumber, // 合同编号
              contractName: this.ruleForm.contractName, // 合同名称
              bizNo: this.ruleForm.shrk, // 送货单号
              orderNo: this.ruleForm.dd,
              receiptNo: '',  // 收货单号
              deliveryNo: '', // 送货单号
              goodsName: this.ruleForm.pm2, // 品名
              spec: this.ruleForm.ggxh2, // 规格型号
              unit: this.ruleForm.dw2, // 单位
              num: this.ruleForm.sl2, // 数量
              unitPrice: this.ruleForm.dj2, // 单价
              totalPrice: this.ruleForm.zj2, // 总价
              receivableAmount: this.ruleForm.shnum // 发票金额
            };
          }
        });
      } else if (ruleFormType == '1') {
        this.$refs.ruleForm3.validate((valid) => {
          if (valid && this.isValidate) {
            this.isSubmit = true;
            // 订单
            params = {
              ...sameType,
              receivableStartTime: this.ruleForm.djTime, // 开票日期
              receivableEndTime: '', // 结束日期
              contractNumber: this.ruleForm.contractNumber, // 合同编号
              contractName: this.ruleForm.contractName, // 合同名称
              bizNo: this.ruleForm.deliveryNo, // 订单号
              orderNo: '',
              receiptNo: '',  // 收货单号
              deliveryNo: '', // 送货单号
              goodsName: this.ruleForm.pm, // 品名
              spec: this.ruleForm.ggxh, // 规格型号
              unit: this.ruleForm.dw, // 单位
              num: this.ruleForm.sl, // 数量
              unitPrice: this.ruleForm.dj, // 单价
              totalPrice: this.ruleForm.zj, // 总价
              receivableAmount: this.ruleForm.ddnum // 发票金额
            };
          }
        });
      } else if (ruleFormType == '3') {
        this.$refs.ruleForm5.validate((valid) => {
          if (valid && this.isValidate) {
            this.isSubmit = true;
            // 结算单
            params = {
              ...sameType,
              receivableStartTime: this.ruleForm.djTime3, // 开票日期
              receivableEndTime: '', // 结束日期
              contractNumber: this.ruleForm.contractNumber, // 合同编号
              contractName: this.ruleForm.contractName, // 合同名称
              bizNo: this.ruleForm.jsnum, // 结算单号
              orderNo: '',
              receiptNo: this.ruleForm.orderNo,  // 收货单号
              deliveryNo: '', // 送货单号
              goodsName: this.ruleForm.pm3, // 品名
              spec: this.ruleForm.ggxh3, // 规格型号
              unit: this.ruleForm.dw3, // 单位
              num: this.ruleForm.sl3, // 数量
              unitPrice: this.ruleForm.dj3, // 单价
              totalPrice: this.ruleForm.zj3, // 总价
              receivableAmount: this.ruleForm.jsdnum // 发票金额
            };
          }
        });
      } else if (ruleFormType == '4') {
        this.$refs.ruleForm2.validate((valid) => {
          if (valid && this.isValidate) {
            this.isSubmit = true;
            // 发票
            params = {
              ...sameType,
              receivableStartTime: this.ruleForm.startTime, // 开票日期
              receivableEndTime: '', // 结束日期
              contractNumber: this.ruleForm.contractNumber, // 合同编号
              contractName: this.ruleForm.contractName, // 合同名称
              invoiceCode: this.ruleForm.invoiceCode, // 发票代码
              checkCode: this.ruleForm.checkCode, // 发票校验码
              bizNo: this.ruleForm.lnvoiceNumber, // 发票号码
              orderNo: this.ruleForm.ddh, // 订单号
              receiptNo: '',  // 收货单号
              deliveryNo: this.ruleForm.receiptNo, // 送货单号
              goodsName: this.ruleForm.goodsName, // 品名
              spec: this.ruleForm.spec, // 规格型号
              unit: this.ruleForm.unit, // 单位
              num: this.ruleForm.num, // 数量
              unitPrice: this.ruleForm.unitPrice, // 单价
              totalPrice: this.ruleForm.totalPrice, // 总价
              receivableAmount: this.ruleForm.contractAmount, // 发票金额
              signDate: this.ruleForm.signDate // 签署日期
            };
          }
        });
      } else if (ruleFormType == '5') {
        this.$refs.ruleForm6.validate((valid) => {
          if (valid && this.isValidate) {
            this.isSubmit = true;
            // 银承
            params = {
              ...sameType,
              receivableStartTime: this.ruleForm.cpTime, // 出票日期
              receivableEndTime: this.ruleForm.receivableEndTime, // 汇票到期日
              bizNo: this.ruleForm.pjnum, // 票据号码
              drawer: this.ruleForm.cprqc, // 出票人全称
              acceptor: this.ruleForm.cdrname, // 承兑人全称
              acceptorBank: this.ruleForm.cdrkname, // 承兑人开户行
              acceptorBankSwift:this.ruleForm.acceptorBankSwift,//承兑人开户行行号
              contractNumber:this.ruleForm.contractNumber,//合同编号
              contractName: this.ruleForm.contractName, // 合同名称
              receivableAmount: this.ruleForm.pmnum // 票面金额
            };
          }
        });
      } else if (ruleFormType == '6') {
        this.$refs.ruleForm7.validate((valid) => {
          if (valid && this.isValidate) {
            this.isSubmit = true;
            // 商承
            params = {
              ...sameType,
              receivableStartTime: this.ruleForm.cpTime2, // 出票日期
              receivableEndTime: this.ruleForm.receivableEndTime2, // 汇票到期日
              bizNo: this.ruleForm.pjnum2, // 票据号码
              drawer: this.ruleForm.cprqc2, // 出票人全称
              acceptor: this.ruleForm.cdrname2, // 承兑人全称
              acceptorBank: this.ruleForm.cdrkname2, // 承兑人开户行
              acceptorBankSwift:this.ruleForm.acceptorBankSwift2,//承兑人开户行行号
              contractNumber:this.ruleForm.contractNumber,//合同编号
              contractName: this.ruleForm.contractName, // 合同名称
              receivableAmount: this.ruleForm.pmnum2 // 票面金额
            };
          }
        });
      } else if (ruleFormType == '7') {
        this.$refs.ruleForm8.validate((valid) => {
          if (valid && this.isValidate) {
            this.isSubmit = true;
            // 其他凭证
            params = {
              ...sameType,
              contractNumber:this.ruleForm.contractNumber,//合同编号
              contractName: this.ruleForm.contractName, // 合同名称
              receivableAmount: this.ruleForm.contractAmount //应收账款金额
            };
          }
        });
      }
      if (this.isSubmit) {
        if (this.sysFileIds.length === 0) {
          this.setFailMessage({
            show: true,
            content: '请上传附件'
          });
          return false;
        }
        this.isSubmitting = true;
        billApi.saveFrontVoucherInfo(params).then((res) => {
          this.isSubmitting = false;
          if (res.rspcode == 1) {
            this.setSuccessMessage({
              show: true,
              content: res.rspdesc || '添加成功'
            });
            this.isMasking = false;
            this.DialogInputBankInfo = false;
            this.selectList = [];
            this.selectAllState = false;
            this.getFrontVoucherInfoList();
          } else {
            this.setFailMessage({
              show: true,
              content: res.rspdesc || '数据获取失败'
            });
          }
        })
        .catch((err) => {
          console.error(err)
          this.isSubmitting = false;
        });
      }
    },
    //      添加凭证接口
    saveFrontVoucherInfo (param) {
      applyloanApi
        .saveFrontVoucherInfo(param)
        .then((res) => {
          if (res.rspcode === 1) {
            this.setSuccessMessage({
              show: true,
              content: res.rspdesc || '添加成功'
            });
            this.DialogInputBankInfo = false;
            this.selectList = [];
            this.getFrontVoucherInfoList();
          } else {
            this.setFailMessage({
              show: true,
              content: res.rspdesc || '数据获取失败'
            });
          }
        })
        .catch((error) => {
          this.setFailMessage({
            show: true,
            content: '网络异常，请稍后再试'
          });
        });
    },

    //      切换选中样式
    selectIcon (param) {
      if (this.selectList.includes(param.voucherInfoId)) {
        this.selectList.splice(this.selectList.indexOf(param.voucherInfoId), 1);
      } else {
       this.selectList.push(param.voucherInfoId);
      }
    },

    formTime (value) {
      const time = new Date(value);
      const year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let h = time.getHours();
      let mm = time.getMinutes();
      if (month <= 9) {
        month = `0${month}`;
      }
      if (day <= 9) {
        day = `0${day}`;
      }
      if (h <= 9) {
        h = `0${h}`;
      }
      if (mm <= 9) {
        mm = `0${mm}`;
      }
      return `${year}-${month}-${day}`;
    },

    showPreviewImage (fileId, isImage) {
      const src = `${this.ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${fileId}&tokenId=${this.userInfo.token}`;
      if (isImage) {
        this.filePreview = {
          show: true,
          src
        };
      } else {
        window.open(`${location.origin}${src}`);
      }
    },
    hidePreviewImage () {
      this.filePreview.show = false;
    },

    //      删除附件
    deleteUploadedFile (file) {
      const fileIndex = _.findIndex(
        this.sysFileIds,
        item => item.fileId === file.fileId
      );
      this.sysFileIds.splice(fileIndex, 1);
    },

    beforeFileQueued (file) {
      this.uploader.reset();
      if (this.countSysFile + this.uploader.getFiles().length > 4) {
        return false;
      }
    },
    uploadBeforeSend (obj, data) {
      (data.tokenId = localStorage.getItem('dl_tokenId_bl')),
        (this.isShowProgress = true);
    },
    uploadProgress (file, percent) {
      const _this = this;
      _this.progress = percent * 100;
    },
    uploadSuccess (file, res) {
      const _self = this;
      const arr = _.split(res, ':');

      this.sysFileIds.push({
        fileId: Number(arr[0].replace('sysFile=', '')),
        fileName: file.name,
        uploaderId: file.id
      });

      this.progress = 0;
      this.isShowProgress = false;
    },
    uploadError (file, reason) {
      if (reason === 'http') {
        this.setFailMessage({
          show: true,
          content: '上传出错！请更新浏览器到最新版本或使用谷歌浏览器上传！'
        });
      }
      this.uploader.removeFile(file, true);
      this.progress = 0;
      this.isShowProgress = false;
    },
    uploadValidata (type) {
      switch (type) {
        case 'F_DUPLICATE': // 是否重复
          this.setFailMessage({
            show: true,
            content: '该文件您已经上传过了，请不要重复上传！'
          });
          break;
        case 'Q_TYPE_DENIED': // 文件类型是否满足
          this.setFailMessage({
            show: true,
            content:
              '请上传后缀为.rar，.doc，.docx，.zip，.pdf，.txt，.swf，.wmv，.gif，.png，.jpg，.jpeg，.bmp，.xls，.xlsx的文件'
          });
          break;
        case 'Q_EXCEED_SIZE_LIMIT': // 文件大小是否超出
          this.setFailMessage({
            show: true,
            content: '请上传大小不超过10M的文件'
          });
          break;
      }
    },

    createWebUploader () {
      this.uploader = Webuploader.create({
        auto: true, // 自动上传
        swf: './static/Uploader.swf',
        server: `${this.ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/saveFile.ht`,
        pick: {
          id: '.picker',
          multiple: true
        },
        chunked: true,
        duplicate: true, // 去重
        fileSizeLimit: 1024 * 1024 * 10
        /*accept: {
          title: '*',
          extensions: 'rar,doc, docx, zip, pdf,txt, swf, wmv, gif, png, jpg, jpeg, bmp, xls, xlsx',
        }*/
      });
      this.uploader.on('beforeFileQueued', this.beforeFileQueued);
      this.uploader.on('uploadBeforeSend', this.uploadBeforeSend);
      this.uploader.on('uploadProgress', this.uploadProgress);
      this.uploader.on('uploadSuccess', this.uploadSuccess);
      this.uploader.on('uploadError', this.uploadError);
      this.uploader.on('error', this.uploadValidata);
    },
    dateChange (e, type) {
      if (e) {
	        const date = e.replace(/(\s*)/g, '').replace(/年/, '-').replace(/月/, '-').replace(/日/, '');
        this.ruleForm[`${type}`] = date;
	        if (type == 'receivableStartTime') {
	        	this.ruleForm.receivableStartTime = date;
	        } else if (type == 'receivableEndTime') {
		        this.ruleForm.receivableEndTime = date;
	        }
      }
    },
    importData (type) {
      if (type == 'ocr') {
        this.emptyData();
        this.buyerNameData();
        this.dialogImportVisibleOcr = true;
        this.importUrl = `${this.ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/saveFile.ht`;
      } else {
        this.dialogImportVisibleExcel = true;
        this.importUrl = `${this.ajaxBaseUrl}/loanform/blitem/blLoanAccountVoucherInfo/importExcel.ht`;
      }
      this.excelData = {
        tokenId: localStorage.getItem('dl_tokenId_bl')
      };
      this.ocrData = {
        tokenId: localStorage.getItem('dl_tokenId_bl')
      };
        this.importFlag = 1;
        this.fileList = [];
        this.uploadTip = '点击上传';
        this.processing = false;
     },

     beforeUploadImportExcel (file) {
        const excelfileExtend = '.xls,.xlsx';
        const fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        if (excelfileExtend.indexOf(fileExtend) <= -1) {
        this.setFailMessage({
          show: true,
          content: '文件格式错误'
        });
           return false;
        }
        this.uploadTip = '正在处理中...';
        this.processing = true;
     },
     beforeUploadImportOcr (file) {
        const excelfileExtend = '.zip';
        const fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        if (excelfileExtend.indexOf(fileExtend) <= -1) {
        this.setFailMessage({
          show: true,
          content: '文件格式错误'
        });
           return false;
        }
        this.uploadTip = '正在处理中...';
        this.processing = true;
     },
  // 上传错误
     uploadFailImport (err, file, fileList) {
        this.uploadTip = '点击上传';
        this.processing = false;
        this.setFailMessage({
        show: true,
        content: err
      });
     },
   // 上传成功
     uploadSuccessImport (response, file, fileList) {
        this.uploadTip = '点击上传';
        this.processing = false;
        if (response.code === 0) {
          this.importFlag = 3;
          this.dialogImportVisibleExcel = false;
          this.setSuccessMessage({
          show: true,
          content: '导入成功'
        });
          this.getFrontVoucherInfoList();
          this.selectAllState = false;
          this.selectList = [];
        } else {
        this.setFailMessage({
          show: true,
          content: response.msg
        });
        };
      this.fileList = [];
     },
     uploadSuccessImportOcr (response, file, fileList) {
      this.fileList = [];
      this.fileList[0] = file;
      this.sysFileIds = [];
      this.uploadTip = '点击上传';
      this.processing = false;
      const arr = _.split(response, ':');
      this.sysFileIds.push({
        fileId: Number(arr[0].replace('sysFile=', '')),
        fileName: file.name,
        uploaderId: file.id
      });
     },

    downTemplate () {
      let url = window.location.href;
      if (url.indexOf('#') != -1) {
        url = url.split('#')[0];
      }
      const elink = document.createElement('a');
      elink.style.display = 'none';
      elink.target = '_blank';
      elink.href = `${this.ajaxBaseUrl}/loanform/blitem/blLoanAccountVoucherInfo/downloadExcelTemplate.ht`;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },

    importOcr () {
      this.$refs.ruleFormImport.validate((valid) => {
        if (valid) {
          if (this.sysFileIds.length == 0) {
            this.setFailMessage({
              show: true,
              content: '请先上传导入文件'
            });
            return;
          }
          const loadingInstance = Loading.service({ fullscreen: true, text: '导入中...' });
          const codeSysfiled = this.sysFileIds ? encodeURIComponent(JSON.stringify(this.sysFileIds)) : '';
          this.ruleForm.netAmount = this.ruleForm.netAmount || '';
          billApi.importOcr({
            buyerId: this.ruleForm.buyerId,
            contractNumber: this.ruleForm.contractNumber,
            netAmount: this.ruleForm.netAmount,
            baseProductId: this.ruleForm.baseProductId,
            tokenId: localStorage.getItem('dl_tokenId_bl'),
            signDate: this.ruleForm.signDate,
            sysFileIds: codeSysfiled
          }).then((res) => {
            if (res.code === 0) {
                loadingInstance.close();
                this.dialogImportVisibleOcr = false;
                this.getFrontVoucherInfoList();
                this.selectAllState = false;
                this.selectList = [];
                this.setSuccessMessage({
                  show: true,
                  content: res.msg
                });
              } else {
                loadingInstance.close();
                this.setFailMessage({
                  show: true,
                  content: res.msg
                });
              }
          });
        }
      });
    },

    selectAll(){
      let pageList = this.tableData4;
      if (pageList.length == 0) {
        return false;
      }
      let idList =  pageList.map((item) => item.voucherInfoId);

      this.selectAllState = !this.selectAllState;
      if(this.selectAllState){
        idList.forEach((voucherInfoId) => {
          if(!this.selectList.includes(voucherInfoId)){
            this.selectList.push(voucherInfoId);;
          }
        });
      }else{
        idList.forEach(id=>{
          let index = this.selectList.findIndex((selectedId) => id == selectedId);
          this.selectList.splice(index, 1);
        });
      }

    }
  },
  mounted () {
    this.$store.commit('changeActive', 3);
    this.getByNodeKeyPC({
      NodeKeys: 'AccountVoucherState,AccountVoucherAuthResult,voucher_type'
    });
    if(this.$route.query.yanse == 1){
      this.showAddBut = false;
    }
    this.getProductList();
    this.getFrontVoucherInfoList();
  }
};
</script>
<style lang="scss">
@import "../../styles/fileUpload";
@import "../../styles/bankcardList";
.hide-dialog{
 display:none;
}
body {
  padding-right: 0 !important;
}
.step3-form .step-form__title {
  padding-bottom: 20px;
}
.step-form-container {
  border: 1px solid #ddd;
  padding: 20px 10px;
  .step-from-top {
    border-bottom: 1px solid #ddd;
    width: 100%;
    height: 130px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    .amount-item {
      width: 25%;
      height: 110px;
      display: inline-block;
      .amount-title {
        text-align: center;
        margin-top: 20px;
        font-size: 18px;
        color: #ff8b38;
        font-family: "Microsoft YaHei";
      }
      .amount-title2 {
        text-align: center;
        margin-top: 20px;
        font-size: 18px;
        color: #36A444;
        font-family: "Microsoft YaHei";
      }
      .amount-title-en {
        text-align: center;
        margin-top: 7px;
        font-size: 13px;
        color: #3e454d;
        font-family: "Microsoft YaHei";
      }

      .amount-money {
        text-align: center;
        margin-top: 10px;
        font-size: 30px;
        font-weight: bold;
        color: #34495e;
        font-family: "Microsoft YaHei";
        em {
          font-style: normal;
          font-family: "Microsoft YaHei";
        }
      }
      .amount-item-top {
        margin-left: 20px;
        height: 50px;
        text-align: left;
        width: 100%;
      }
      .amount-item-btn {
        margin-right: 10px;
        background-color: #34495e;
        color: #ffffff;
        padding: 5px 15px 5px 15px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
        cursor: pointer;
      }
      .amount-item-btn-import {
        width:30px;
        margin-right: 10px;
        background-color: #34495e;
        color: #ffffff;
        padding: 5px 15px 5px 15px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
        cursor: pointer;
      }
    }
    .amount-item:last-child {
      width: 45%;
    }
    .amount-item:nth-child(2) {
      border-left: 1px solid #ddd;
      border-right: 1px solid #ddd;
    }
  }
  .step-from-bottom {
    .step-list {
      .step3-list-li:hover {
        cursor: pointer;
        background-color: #efefef;
      }
      li {
        border-bottom: 1px solid #ddd;
        height: 50px;
        line-height: 50px;
        display: flex;
        span {
          vertical-align: middle;
          display: inline-block;
          // width: 23%;
          flex: 1;
          text-align: center;
          font-size: 12px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .checkbox_selectAll{
          display: inline-block;
          height: 18px;
          width: 18px;
          border-radius: 50%;
          background: url("../../assets/images/select.png") no-repeat;
          -webkit-background-size: 100% 100%;
          background-size: 100% 100%;
          border: 1px solid #ff8b38;
        }
        .select_All {
            display: inline-block;
            vertical-align: middle;
            width: 18px;
            font-style: normal;
            text-align: center;
            height: 18px;
            border: 1px solid #ddd;
            border-radius: 50%;
        }
        .first_checkbox {
          display: inline-block;
          // width: 21%;
          flex: 1;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            display: inline-block;
            vertical-align: middle;
            width: 18px;
            text-align: center;
            height: 18px;
            border: 1px solid #ddd;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            border-radius: 50%;
          }
          .first_checkbox_select {
            background: url("../../assets/images/select.png") no-repeat;
            -webkit-background-size: 100%;
            background-size: 105%;
            border: 1px solid #ff8b38;
          }
        }
        .step3_blue {
          color: #EB662B;
        }
        .step3_blue2 {
          color: #36A444;
        }
      }
      li:first-child {
        font-size: 12px;
        color: #d1d1d1;
        display: flex;
        span {
          width: 21%;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
        }
        span:first-child {
          width: 21%;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
        }
      }
      .select_span{
        display: flex;
        flex:1;
        font-style: normal;
        text-align: left;
      }
    }
    .step3_pagination {
      text-align: center;
      padding-top: 20px;
    }
    .noData {
      text-align: center;
      color: #d1d1d1;
      margin: 20px 0;
    }
    .step3-amount {
      margin-top: 15px;
      font-size: 12px;
      color: #999;
      display: flex;
      span {
        display: inline-block;
        flex: 1;
        text-align: center;
        i {
          color: #EB662B;
          font-style: normal;
          font-size: 16px;
        }
      }
    }
    .step3-amount2 {
      margin-top: 15px;
      font-size: 12px;
      color: #999;
      display: flex;
      span {
        display: inline-block;
        flex: 1;
        text-align: center;
        i {
          color: #36A444;
          font-style: normal;
          font-size: 16px;
        }
      }
    }
  }
}

.step3__first_checkbox {
  display: inline-block;
  width: 105px;
  padding-left:10px;
  text-align: left;
  i {
    display: inline-block;
    vertical-align: middle;
    width: 18px;
    text-align: center;
    height: 18px;
    border: 1px solid #ddd;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
  }
  .first_checkbox_select {
    background: url("../../assets/images/select.png") no-repeat;
    -webkit-background-size: 100%;
    background-size: 105%;
    border: 1px solid #ff8b38;
  }
}

  .el-dialog__footer {
    width: 100%;
    display: flex;
    justify-content: center;
    .el-button {
      width: 100px;
      margin-bottom: 30px;
    }
    .el-button:first-child {
      background: #EB662B;
      color: $white;
      border-color: #EB662B;
    }
  }
.step3-form .financing-dialog {
  .step3Close {
    color: #ff8b38;
    text-align: right;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .el-form-item {
    width: 50%;
    float: left;
  }
  .el-form-item2 {
    width: 100%;
    float: left;
  }
  .el-dialog__body {
    padding: 20px;
  }
  .el-dialog__footer {
    width: 100%;
    display: flex;
    justify-content: center;
    .el-button {
      width: 100px;
      margin-bottom: 30px;
    }
    .el-button:first-child {
      background: #EB662B;
      color: $white;
      border-color: #EB662B;
    }
  }
  .el-input,
  .el-select {
    width: 100%;
    float: left;
    .el-input__inner,
    .el-input {
      width: 100%;
    }
  }
  .file-list__item-preview,
  .file-list__select-file {
    width: 48%;
  }
}
.step-form__step-num2{
      box-shadow: 0 0 46px rgba(253, 180, 69, 0.3);
    position: absolute;
    left: 33px;
    border-radius: 50%;
    width: 52px;
    height: 52px;
    line-height: 52px;
    color: #36A444;
    font-family: "Microsoft YaHei";
    font-weight: 700;
    font-size: 24px;
    text-align: center;
    background-color: #fff;
}
.step-form__step-num{
      box-shadow: 0 0 46px rgba(253, 180, 69, 0.3);
    position: absolute;
    left: 33px;
    border-radius: 50%;
    width: 52px;
    height: 52px;
    line-height: 52px;
    color: #EB662B;
    font-family: "Microsoft YaHei";
    font-weight: 700;
    font-size: 24px;
    text-align: center;
    background-color: #fff;
}
.step-form__btn-prev {
  background:#FF9F75;
  float: left;
  @include step-form__btn;
}
  .step-form__btn-next {
  background:#EB662B;
  float: right;
  @include step-form__btn;
}
 .step-form__btn-prev2 {
  background:#75BC42;
  float: left;
  @include step-form__btn;
}
  .step-form__btn-next2 {
  background:#36A444;
  float: right;
  @include step-form__btn;
}
.step-form__btn-container {
  @include clear;
}
.download{
  display: inline-flex;
  position: absolute;
  left: 100px;
  top: 68px;
}
</style>



// WEBPACK FOOTER //
// Step3.vue?2f8c7024